import { render } from "./userProfileHeader.vue?vue&type=template&id=5f89ec23&scoped=true"
import script from "./userProfileHeader.vue?vue&type=script&lang=js"
export * from "./userProfileHeader.vue?vue&type=script&lang=js"

import "./userProfileHeader.vue?vue&type=style&index=0&id=5f89ec23&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f89ec23"]])

export default __exports__